module.exports = __webpack_public_path__ + "media/images/favicon-891fd4f3ad3542e4e4f902c1c09ceaa3.png";